import { render, staticRenderFns } from "./StopWords.html?vue&type=template&id=1f316585&scoped=true&"
import script from "./StopWords.vue?vue&type=script&lang=js&"
export * from "./StopWords.vue?vue&type=script&lang=js&"
import style0 from "./StopWords.vue?vue&type=style&index=0&id=1f316585&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f316585",
  null
  
)

export default component.exports